<template>
  <div>
    <div v-if="isCheckoutPage || isPaymentConfirmPage || totalInfo"
         :class="$style.checkoutTotalMain">

      <div v-if="!isKioskPlatform"
           :class="$style.checkoutTotalInfo">

        <div :class="$style.checkoutInfo">
          <span>Subtotal</span>
          <span>{{ subTotalCheckout | toPrice }}</span>
        </div>
        <div :class="$style.checkoutInfo">
          <span>Discount</span>
          <span>{{ discount | toPrice }}</span>
        </div>
        <div :class="$style.checkoutInfo">
          <span>Tax</span>
          <span>{{ taxCheckout | toPrice }}</span>
        </div>
        <div :class="$style.checkoutTotalOrder">
          <span>Total Order</span>
          <span :class="$style.checkoutTotalPrice">
            {{ totalPriceCheckout | toPrice }}
          </span>
        </div>

        <div :class="$style.discountInfo">
          <form :class="$style.discountForm"
                @submit.prevent="onDiscountSubmit">
            <!-- Here should be validation that will check
            if the value matches some authorized discount value
            so the validation should be refactored
            after the real API will be implemented-->
            <div :class="$style.discountFieldWrap">
              <InputField :class="[$style.discountField,
                                   {[$style.errorField] :
                          $v.discountField.$error }]"
                          v-model="$v.discountField.$model"
                          :disabled="disableDiscountField"
                          :maxlength="$v.discountField.$params.maxLength.max"
                          label="Discount Code*"/>
              <template>
                <button v-if="hasAppliedDiscount"
                        :class="[$style.discountSubmit, $style.discountReset]"
                        :disabled="discountCodeIsUpdating"
                        type="button"
                        @click="resetDiscount">
                  X
                </button>
                <button v-else
                        :class="$style.discountSubmit"
                        :disabled="disableDiscountField"
                        type="button"
                        @click="onDiscountSubmit">
                  Submit
                </button>
              </template>
            </div>
            <p v-if="!$v.discountField.maxLength"
               :class="$style.errorMessage">
              Maximum length {{ $v.discountField.$params.maxLength.max }}
              characters.
            </p>
            <div v-else-if="discountErrors.length">
              <p v-for="(error, index) in discountErrors"
                 :key="index"
                 :class="$style.errorMessage">
                {{ error }}
              </p>
            </div>
            <!-- This message should be shown
            when the validation is successful -->
            <p v-else-if="!$v.discountField.$error && hasAppliedDiscount"
               :class="$style.discountApplied">
              Discount code applied!
            </p>
          </form>
        </div>
      </div>

      <div v-else
           :class="$style.checkoutTotalKiosk">
        <button :class="$style.addBtn"
                @click="handleAddItem">
          <span>
            <svg v-svg
                 :class="$style.plusIcon"
                 symbol="plus-sign"/>
          </span>
          Add Item
        </button>

        <div :class="$style.checkoutInfo">
          <span>Subtotal: $ {{ 19.31 }}</span>
          <span>Tax: $ {{ 3.29 }}</span>
        </div>
        <div :class="$style.checkoutTotal">
          <button :class="$style.discountBtn">Have a Discount Code?</button>
          <span>Total: $ {{ 40.33 }}</span>
        </div>

        <div :class="$style.checkoutButtonsKiosk">
          <BaseButton :class="$style.startBtn"
                      button-style="Back"
                      @click="handleStartOver">
            Start Over
          </BaseButton>
          <BaseButton :class="$style.checkoutBtn"
                      :disabled="!cartCompleted"
                      button-style="Main"
                      @click="handleCheckout">
            Checkout
          </BaseButton>
        </div>
      </div>
    </div>

    <div v-else
         :class="$style.totalOrderButtons">
      <button :class="$style.addBtn"
              @click="handleAddItem">
        <span>
          <svg v-svg
               :class="$style.plusIcon"
               symbol="plus-sign"/>
        </span>
        Add Item
      </button>
      <div :class="[$style.subtotal, {[$style.isLoading]: cartOrderIsUpdated}]">
        <LoadingSpinner v-if="cartOrderIsUpdated"/>
        <template v-if="calculatedOrder">
          <div :class="$style.subtotalItem">
            <h6>Subtotal</h6>
            <span>{{ subTotalCalc | toPrice }}</span>
          </div>
          <div :class="$style.subtotalItem">
            <h6>Tax</h6>
            <span>{{ taxCalc | toPrice }}</span>
          </div>
        </template>
        <div v-if="isKioskPlatform && discount > 0"
             :class="$style.subtotalItem">
          <h6>Discount</h6>
          <span>{{ discountCalc | toPrice }}</span>
        </div>
        <div :class="[$style.subtotalItem, $style.subtotalItemBold]">
          <h6>Total</h6>
          <span v-if="isKioskPlatform && order && order.discountPrice > 0">
            {{ totalPriceCalc | toPrice }}
          </span>
          <span v-else>{{ totalPriceCalc | toPrice }}</span>

        </div>
        <div v-if="!isKioskPlatform">
          <p :class="$style.discountMessage">
            Discounts will be reflected at checkout.
          </p>
        </div>

        <div v-if="isKioskPlatform && discount === 0">
          <button :class="$style.kioskDiscountBtn"
                  @click="enterDiscountCode">Have a Discount Code?</button>
        </div>
      </div>

      <div v-if="!isKioskPlatform"
           :class="$style.checkoutButtons">
        <BaseButton :class="$style.squareButton"
                    :disabled="cartLength === 0"
                    button-style="Main"
                    @click="handleStartOver">
          Start Over
        </BaseButton>
        <BaseButton :class="$style.squareButton"
                    :disabled="!cartCompleted"
                    button-style="Main"
                    @click="handleCheckout">
          Checkout
        </BaseButton>
      </div>
      <div v-if="isKioskPlatform"
           :class="$style.checkoutButtonsKiosk">
        <BaseButton :class="$style.startBtn"
                    :disabled="cartLength === 0"
                    button-style="Main"
                    @click="handleStartOver">
          Start Over
        </BaseButton>
        <BaseButton :class="$style.checkoutBtn"
                    :disabled="!cartCompleted"
                    button-style="Main"
                    @click="handleCheckout">
          Checkout
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_MODAL } from '@/apps/auth/store/types';
import { DISCOUNT_CODE_CHANGED, SHOW_CHECKOUT_DIALOG, UPDATE_DISCOUNT } from '@/apps/cart/store/types';
import LoadingSpinner from '@/apps/configurator/components/LoadingSpinner';
import { MODAL_UPDATE } from '@/apps/core/store/types';
import BaseButton from '@/components/BaseButton';
import InputField from '@/components/InputField';
import Vue from 'vue';
import Component from 'vue-class-component';
import { maxLength } from 'vuelidate/lib/validators';
import { Action, Getter } from 'vuex-class';

/**
 * Renders order data in the cart footer.
 */
@Component({
  components: {
    LoadingSpinner,
    BaseButton,
    InputField,
  },
  validations: {
    discountField: { maxLength: maxLength(20) },
  },
  props: {
    currentPage: '',
    totalInfo:   {
      type:     Boolean,
      required: false,
      default:  false,
    },
  },
  watch: {
    /**
     * Resets discount value at cancel checkout for guest user.
     */
    showCart() {
      if (!this.isCheckoutPage && this.isGuest && !this.showCart) {
        this.discountField = '';
      }

      if (this.isCheckoutPage) {
        this.discountField = this.order.promotionCodeApplied;
      }
    },
  },
})
export default class CartTotal extends Vue {
  @Getter isAuthenticated;
  @Getter isGuest;
  @Getter orderTotalPrice;
  @Getter isKioskPlatform;
  @Getter isMobilePlatform;
  @Getter order;
  @Getter cartCompleted;
  @Getter cartLength;
  @Getter calculatedOrder;
  @Getter cartOrderIsUpdated;
  @Getter guestAccountData;
  @Getter authUser;
  @Getter showCart;
  @Getter discountCodeIsUpdating;
  @Getter hasAppliedDiscount;
  @Getter taxCheckout;
  @Getter taxCalc;
  @Getter discount;
  @Getter discountCalc;
  @Getter discountErrors;
  @Getter discountCode;

  @Action(AUTH_MODAL) setAuthModal;
  @Action(MODAL_UPDATE) modalUpdate;
  @Action(SHOW_CHECKOUT_DIALOG) showMobileCheckoutModal;
  @Action(UPDATE_DISCOUNT) updateDiscount;
  @Action(DISCOUNT_CODE_CHANGED) changeDiscountCode;
  discountCodeTmp = '';
  checkout = false;

  get disableDiscountField() {
    return this.hasAppliedDiscount || this.discountCodeIsUpdating;
  }

  get discountField() {
    return this.discountCode.toUpperCase();
  }

  set discountField(value) {
    this.changeDiscountCode(value || '');
  }

  get isCheckoutPage() {
    return this.currentPage === 'checkout';
  }

  get isPaymentConfirmPage() {
    return this.currentPage === 'payment-confirm';
  }

  get subTotalCheckout() {
    return Number(this.order.subtotal) || 0;
  }
  get subTotalCalc() {
    return Number(this.calculatedOrder.subtotal) || 0;
  }

  /**
   * Get total price from order if order is exists
   * if the order has not yet been created, calculate from the menu
   */
  get totalPriceCheckout() {
    return this.order ? Number(this.order.totalPrice) : this.orderTotalPrice;
  }
  get totalPriceCalc() {
    return this.calculatedOrder ?
      Number(this.calculatedOrder.totalPrice) : this.orderTotalPrice;
  }

  mounted() {
    this.setInitialDiscount();
  }

  /**
   * Set initial discount and promo code from order API.
   */
  setInitialDiscount() {
    if (this.order) {
      const { promotionCodeApplied } = this.order;

      this.discountField = promotionCodeApplied;
    }
  }

  /**
   * Handle discount code change.
   */
  async onDiscountSubmit() {
    try {
      await this.updateDiscount();
    } catch (e) {
      // error is handled in submitDiscount
    }
  }

  async resetDiscount() {
    await this.changeDiscountCode('');
    await this.updateDiscount();
  }

  /**
   * Emits "checkout" event with promotion code if it exists.
   */
  emitCheckout() {
    const userData = this.isGuest ? this.guestAccountData : this.authUser;

    if (this.order && this.order.promotionCodeApplied) {
      this.$emit('checkout', { userData, promoCode: this.order.promotionCodeApplied });
    } else if (this.isKioskPlatform
      || (this.isAuthenticated && !this.isGuest) || this.order) {
      this.$emit('checkout', { userData });
    }
  }

  /**
   * Event handler for clicking the "checkout" button
   *
   * If the user is authorized, we forward it to the checkout page.
   * If not authorized, show the modal.
   */
  handleCheckout() {
    if (this.isKioskPlatform || (this.isAuthenticated && !this.isGuest) || (this.order)) {
      this.emitCheckout();
    } else if (this.isMobilePlatform) {
      this.showMobileCheckoutModal();
      this.emitCheckout();
    } else {
      this.modalUpdate({
        name: 'checkoutModal',
        data: true,
      });
    }
  }

  /**
   * Event handler for "add item"
   */
  handleAddItem() {
    this.$emit('add-item');
  }

  /**
   * Event handler for "Start Over"
   */
  handleStartOver() {
    this.$emit('start-over');
  }

  get checkoutStyle() {
    if (this.cartCompleted) {
      return [this.$style.squareButton];
    }

    return [ this.$style.squareButton, this.$style.disabledButton ];
  }

  /**
   * Event handler for clicking discount button
   */
  enterDiscountCode() {
    this.$router.push({ name: 'discount' });
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";
@import "~@/style/helpers.scss";

.checkoutTotalMain {
  background-color: $light-choice-bg;
}

.checkoutTotalInfo {
  display: flex;
  flex-flow: row wrap;
  padding: 19px 0 23px;
}

.checkoutInfo {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-left: 20px;
  padding-right: 16px;
  font-family: 'Gotham', sans-serif;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: -0.18px;
  line-height: 20px;
}

.checkoutTotalOrder {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-left: 20px;
  padding-right: 16px;
  margin-top: 18px;
  margin-bottom: 10px;
  font-family: 'Gotham', sans-serif;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.21px;
  line-height: 20px;
}

.checkoutTotalPrice {
  font-size: 20px;
}

.discountInfo {
  width: 100%;
}

.discountForm {
  position: relative;
  width: 100%;
  padding-left: 20px;
  padding-right: 16px;
}

.discountInfo .discountForm .discountField input {
  font-family: 'Gotham', sans-serif;
  font-size: 15px;
  font-weight: 300;
  color: $black-semi-transparent;
}

.discountApplied {
  color: $green-color;
  font-weight: 300;
  font-style: italic;
  font-size: 12px;
  text-align: center;
  margin-top: -10px;
}

.discountMessage {
  color: $green-color;
  font-weight: 300;
  font-style: italic;
  font-size: 12px;
  text-align: center;
  margin-top: 10px;
}

.discountInfo .discountForm .discountField label {
  font-family: 'Gotham', sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: $green-color;
}

.discountInfo .discountForm .discountField.errorField label {
  color: red;
}

.discountInfo .discountForm {
  .discountField.errorField > div > div::before {
    border-color: $red-color;
  }
}

.errorMessage {
  text-align: left;
  font-size: 12px;
  font-style: italic;
  color: $red-color;
  margin-top: -16px;
  margin-bottom: 14px;
}

.addBtn {
  width: 100%;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-shadow: 0 1px 2px 0 rgba(125, 125, 125, 0.37);
  font-family: 'Gotham', sans-serif;
  font-size: 17px;
  color: $black-slightly-transparent;
  line-height: 24px;
  font-weight: 700;
  text-transform: uppercase;
  outline: none;

  span {
    border: 2px solid $green-color;
    border-radius: 50%;
    width: 27px;
    height: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    padding-left: 1px;
  }

  .plusIcon {
    fill: $black;
    width: 10px;
    height: 10px;
  }
}

.discountField {
  input {
    padding-right: 62px;
  }
}

.subtotal {
  position: relative;
  padding: 15px 13px 15px 21px;
  box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.23);
  background-color: $light-choice-bg;
}
.subtotalItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 300;

  h6 {
    font-weight: 300;
  }

  span {
    font-family: 'Gotham', sans-serif;
    color: $black;
  }
}
.subtotalItemBold {
  font-weight: 400;

  h6 {
    font-weight: 400;
  }

  span {
    font-size: 20px;
  }
}
.subtotal.isLoading {
  .subtotalItem {
    visibility: hidden;
  }
}

.checkoutButtons {
  background-color: $white;
  width: calc(100% - 2px);
  display: flex;
  justify-content: space-between;

  .squareButton {
    border-radius: 0;
    width: calc(50% - 1px);
    background: linear-gradient(180deg, #58C762 0%, #16961E 100%);
    padding: 22px;
    margin: 0;
    box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.37);
    outline: none;
    height: auto;

    div {
      color: $white;
      text-transform: uppercase;
      font-family: 'Gotham', sans-serif;
      font-size: 18px;
      line-height: 16px;
      font-weight: 700;
    }
  }
}

.checkoutButtonsKiosk {
  padding: 40px 35px;

  button {
    margin: 0 10px;
    width: calc(50% - 20px); /* 100% minus width of the margins 10px each */
    height: 100px;
  }

  .startBtn {
    border-radius: 50px;
    font-size: 30px;
    line-height: 38px;
  }

  .checkoutBtn {
    border-radius: 50px;
    font-size: 30px;
    line-height: 38px;
  }
}

.checkoutTotalKiosk {
  .checkoutInfo {
    padding: 24px 46px;
    border-bottom: 2px dashed $checkout-info-color;
    font-size: 34px;
    font-weight: 700;
    letter-spacing: 0.19px;
    line-height: 48px;
  }

  .checkoutTotal {
    padding: 24px 46px;
    display: flex;
    justify-content: space-between;
    font-family: 'Gotham', sans-serif;
    font-size: 34px;
    font-weight: 900;
  }

  .discountBtn {
    color: $links-color;
    font-size: 26px;
    font-weight: 300;
    text-transform: uppercase;
  }

  .checkoutButtonsKiosk {
    background-color: $white;
    box-shadow: 0 -4px 2px 0 rgba(181, 181, 181, 0.6);
  }
}

.discountFieldWrap {
  position: relative;

  .discountSubmit {
    position: absolute;
    top: 45%;
    right: 0;
    transform: translateY(-50%);
    color: $links-color;
    outline: none;
    font-family: $main-font-family;
    font-size: rem(14px);
    font-weight: 300;
    text-align: center;
    background: transparent;
    cursor: pointer;
    padding: 10px 0 10px 10px;

    &:disabled {
      opacity: 0.3 !important;
    }
  }

  .discountReset {
    font-weight: 400;
    font-size: 18px;
    padding-right: 10px;
    opacity: 0.6;
  }
}

.kioskDiscountBtn {
  font-family: $main-font-family;
  color: $links-color;
  font-size: 26px;
  font-weight: 300;
  text-transform: uppercase;
  margin-top: 10px;
}

@media screen and (max-width: $kiosk-breakpoint-max) {
  .addBtn {
    padding: 18px;
    box-shadow: 0 -1px 5px 0 rgba(139, 139, 139, 0.81);
    font-size: 30px;
    line-height: 38px;

    span {
      border: 3px solid $green-color;
      width: 54px;
      height: 54px;
      margin-right: 22px;
    }

    .plusIcon {
      width: 18px;
      height: 18px;
    }
  }
  .subtotal {
    padding: 28px 45px;

    h6 {
      font-size: 34px;
    }

    span {
      font-size: 34px;
      font-weight: 700;
    }
  }

  .checkoutButtonsKiosk {
    display: flex;
  }

  .checkoutTotalKiosk {
    display: block;
  }
}

@media screen and (max-width: $mobile-breakpoint-max) {
  .addBtn {
    width: 100%;
    padding: 6px;
    box-shadow: 0 1px 2px 0 $mobile-header-shadow-color;
    font-size: rem(14px);

    span {
      border: 2px solid $green-color;
      width: 27px;
      height: 27px;
      margin-right: 8px;
    }

    .plusIcon {
      width: 10px;
      height: 10px;
    }
  }

  .subtotal {
    padding: $mobile-content-side-padding;
    box-shadow: 0 -1px 4px 0 $mobile-subtotal-shadow-color;
    background-color: $mobile-subtotal-color;

    h6 {
      font-size: rem(15px);
      letter-spacing: rem(-0.21px);
    }

    span {
      font-size: rem(15px);
      letter-spacing: rem(-0.21px);
      font-weight: 500;
    }
  }

  .checkoutButtons,
  .checkoutTotalInfo {
    display: flex;
    background: $white;
  }

  .checkoutButtons button.squareButton {
    height: 50px;
    padding: 10px;
    width: calc(50% - 1px);

    div {
      font-size: rem(14px);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/apps/cart/components/CartTotal.vue